import { ApolloError, useApolloClient, useLazyQuery } from '@apollo/client'
import { GET_USERS_SUGGESTIONS, USER_SUGGESTION_FRAGMENT } from 'features/Users/queries-legacy'
import { GTUserSuggestion, GTUserSuggestionsResponse } from 'gql/types.generated'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'

interface IUseUserSuggestionsByIdsQueryOptions {
  ids: string[]
  skip?: boolean
}

interface IUseUserSuggestionsByIdsQueryResponse {
  users: GTUserSuggestion[]
  loading?: boolean
  error?: ApolloError
}

export const useUserSuggestionsByIdsQuery = ({
  ids,
  skip
}: IUseUserSuggestionsByIdsQueryOptions): IUseUserSuggestionsByIdsQueryResponse => {
  const client = useApolloClient()
  const [users, setUsers] = useState<GTUserSuggestion[]>([])
  const [getUsers, { loading, error }] = useLazyQuery<{ userSuggestions: GTUserSuggestionsResponse }>(
    GET_USERS_SUGGESTIONS,
    {
      variables: {
        input: {
          ids
        }
      }
    }
  )

  const findUsers = async (ids: string[]): Promise<void> => {
    const cachedUsers = ids.map((id) =>
      client.readFragment<GTUserSuggestion>({ id: `UserSuggestion:${id}`, fragment: USER_SUGGESTION_FRAGMENT })
    )
    if (cachedUsers.every((user) => !!user)) {
      setUsers(cachedUsers as GTUserSuggestion[])
    } else {
      const usersResponse = await getUsers({
        variables: {
          input: {
            ids
          }
        }
      })
      setUsers(usersResponse.data?.userSuggestions.items || [])
    }
  }

  useEffect(() => {
    if (!skip) {
      findUsers(ids)
    }
  }, [ids.toString(), skip])

  return {
    users: !isEmpty(ids) ? users : [],
    loading,
    error
  }
}
